var client = false;
$( document ).ready(function() {
	client = new cClient();
});

function cClient(){
	var self = this;
	//Only run on /clients/ pages.
	if(window.location.href.indexOf("/clients/") > -1) {
       this.onload();
    }
}

cClient.prototype.onload = function(){

	$(".save").click(function(e){
		$(this).prop("disabled", "disabled");
		$('#edit-profile').submit();
	});

	var phoneEls = $('.client-phone');
	$(phoneEls).each(function(index, el){
		this.oninvalid = function(){
			this.setCustomValidity('Please input a phone number in format 555-555-5555');
		};
		this.oninput = function(){
			this.setCustomValidity('');
		};

		InputMask({"mask": "999-999-9999"}).mask(el);

	});

	InputMask({"mask": "a9a 9a9"}).mask($('input.postalcode')[0]);

	$('#ins-same-dob').click(function(){
		if(this.checked){
			$('#ins-dateofbirth').val($('#client-dob').val());
			$('#ins-dateofbirth').attr('readonly','readonly');
		}else{
			$('#ins-dateofbirth').removeAttr('readonly');
		}
	});

}
